import React from 'react';
import SectionTitle from '../ui/SectionTitle';
import Card, { CardContent } from '../ui/Card';
import './Services.css';

const CallCenterServices = () => {
    const services = [{
            title: 'Inbound Customer Support',
            description: 'Professional handling of all incoming customer inquiries'
        },
        {
            title: 'Outbound Campaigns',
            description: 'Strategic outbound calling for customer engagement'
        },
        {
            title: 'CRM Management',
            description: 'Comprehensive customer relationship management'
        },
        {
            title: 'Lead Generation',
            description: 'Targeted telemarketing and lead qualification'
        },
        {
            title: 'Feedback & Surveys',
            description: 'Customer insight gathering and analysis'
        },
        {
            title: 'Technical Support',
            description: 'Expert technical assistance for your customers'
        }
    ];

    return ( <
        section className = "services-section" >
        <
        div className = "container" >
        <
        SectionTitle subtitle = "OUR SERVICES"
        title = "Comprehensive Solutions" /
        >
        <
        p className = "services-subtext" >
        End - to - end call center and debt recovery services tailored to your business needs <
        /p>

        <
        h2 className = "service-category-title" > Call Center Services < /h2>

        <
        div className = "services-grid" > {
            services.map((service, index) => ( <
                Card key = { index } >
                <
                CardContent >
                <
                h3 > { service.title } < /h3> <
                p > { service.description } < /p> <
                /CardContent> <
                /Card>
            ))
        } <
        /div> <
        /div> <
        /section>
    );
};

export default CallCenterServices;